<template>
  <v-btn
    elevation="0"
    class="default-btn-styling"
    :class="{ 'btn-height-large': size === 'large', 'btn-hover': buttonColor === '#128279' }"
    :style="{ background: buttonColor, color: fontColor }"
    @click="$emit('click')"
    :disabled="rightBtnDisabled"
    :outlined="outlined"
  >
    {{ label }}
  </v-btn>
</template>

<script>
export default {
  name: 'Button',
  props: {
    label: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    primary: {
      type: Boolean,
      default: false
    },
    buttonColor: {
      type: String,
      default: ''
    },
    fontColor: {
      type: String,
      default: ''
    },
    rightBtnDisabled: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.btn-height-large {
  width: 189px !important;
}

.btn-height-small {
  width: 99px;
}

.default-btn-styling {
  height: 40px !important;
  font-size: 14px !important;
  width: 129px;
  background: #e8eaed;
  font-style: normal;
  font-weight: 700;
}
.btn-primary {
  background: #128279 !important;
  color: #ffffff !important;
}
.theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  background-color: #dadadc !important;
}

.v-btn--outlined {
  border-width: 2px !important;
}

.btn-hover:hover {
  background-color: #0C4851 !important
}

</style>
